import React from "react";
import { Typography, Card, Box, Grid } from "@mui/material";
import { styled } from "@mui/system";
import { CustomLabel, CustomValue } from "./CustomTypography";
import ViewButton from "../Famer/ViewButton";
const StyledDetailsCard = styled(Card)({
  border: "1px solid #A5A5A5",
  marginBottom: "10px",
});

const DetailsCardContent = styled(Box)({
  padding: "10px",
});

const DetailsList = ({ data, buttonList }) => {
  return (
    <StyledDetailsCard>
      <DetailsCardContent>
        <Grid container>
          {data.map(({ label, value }, index) => (
            <>
              <Grid item xs={6}>
                <CustomLabel>
                  <Typography key={index} variant="body1">
                    {label}:
                  </Typography>
                </CustomLabel>
              </Grid>
              <Grid item xs={6}>
                <CustomValue>
                  <Typography key={index} variant="body1">
                    {value}
                  </Typography>
                </CustomValue>
              </Grid>
            </>
          ))}
          <div style={{ marginTop: "40px" }}></div>

          {buttonList && (
            <>
              {buttonList.map((button, index) => (
                <Grid
                  key={index}
                  item
                  xs={12}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <ViewButton label={button} />
                </Grid>
              ))}
            </>
          )}
        </Grid>
      </DetailsCardContent>
    </StyledDetailsCard>
  );
};

export default DetailsList;
